export default __webpack_public_path__ + "locales/fr/Files.json?hash=3179c6a4e5897ba471f9749b6e6ec9b3";